var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuests(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.503,
    height: 19,
    viewBox: "0 0 20.503 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M15,19.128a9.415,9.415,0,0,0,6.746-.58,4.125,4.125,0,0,0-7.533-2.493M15,19.128v0a6.348,6.348,0,0,0-.786-3.07M15,19.128v.106a12.389,12.389,0,0,1-12.75,0v-.109a6.375,6.375,0,0,1,11.964-3.07M12,6.375A3.375,3.375,0,1,1,8.625,3,3.375,3.375,0,0,1,12,6.375Zm8.25,2.25A2.625,2.625,0,1,1,17.625,6,2.625,2.625,0,0,1,20.25,8.625Z",
    transform: "translate(-1.749 -2.5)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuests);
export default __webpack_public_path__ + "static/media/guests.f08c5004.svg";
export { ForwardRef as ReactComponent };